import { useState, useRef } from "react";
import { FaSearch } from "react-icons/fa";
import { Search } from "./Search";
import { SearchResultList } from "./SearchResultList";
import "./css/Search.css";
import "./css/MiniSearch.css";
export const SearchComponent = ({
  propsValue,
  handeleClickFind,
  home,
  link,
}) => {
  const [results, setResults] = useState([]);
  const [input, setInput] = useState(
    `${propsValue === undefined ? "" : propsValue}`
  );
  // setInput(propsValue);

  // Скоуп для поиска .results-list внутри ЭТОГО конкретного экземпляра
  // SearchComponent, а не по всему document — иначе при одновременном
  // наличии на странице нескольких SearchComponent (home + mini) они
  // могли бы находить и скрывать/показывать чужой список результатов.
  const containerRef = useRef(null);

  const resultList = {
    home: home,
    handeleClickFind: handeleClickFind,
    setInput: setInput,
    results: results,
    setResults: setResults,
    containerRef: containerRef,
  };
  const searchList = {
    home: home,
    link: link,
    input: input,
    setResults: setResults,
    setInput: setInput,
    containerRef: containerRef,
  };
  return (
    <div
      ref={containerRef}
      className={home ? "search-bar-container" : "mini-search-bar-container"}
    >
      <Search
        link={link}
        home={home}
        setResults={setResults}
        input={input}
        setInput={setInput}
        containerRef={containerRef}
      />
      {results && results.length > 0 && (
        <SearchResultList resultList={resultList} />
      )}
    </div>
  );
};